import { createGlobalStyle, css } from "styled-components"; // TODO: заменить на импорт GlobalBodyFontStyles из ДС. box-sizing вынести

var GlobalThemeV2 = createGlobalStyle(function (_ref) {
  var theme = _ref.theme;
  return css(["*,::after,::before{box-sizing:border-box;}body{font-family:", ";font-size:", ";color:", ";}.pochta-ui-scroll-disable{overflow:hidden;}"], theme.font.fontFamily, theme.font.sizes[theme.font.defaultSize].fontSize, theme.font.color);
});
export default GlobalThemeV2;